var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"outlined":"","x-small":"","color":"grey"},on:{"click":_vm.reload}},[_vm._v("Versão: "+_vm._s(_vm.version))])
}
var staticRenderFns = []

export { render, staticRenderFns }